export enum FormName {
    RESCHEDULE_TECHNICIAN = 'reschedule-technician',
    UPDATE_ACTIVATION_DATE = 'update-activation',
}
